module.exports = __webpack_public_path__ + "static/figure_pecan-home-58b7fc1ede97b0abdefc47bed4382647.png";